import APIClient from "../client";

const userAPI = {
  get: () => {
    return APIClient.get("/user");
  },
};

export default userAPI;
